import React from "react";
import MobilePageLayout from "../components/MobilePageLayout";

const HomePage = ({ onNext }) => {
  return (
    <MobilePageLayout ctaLabel="Next" onCtaClick={() => onNext(null)}>
      <img src="/logo.png" className="logo" alt="LOKRAM" />

      <h2 className="page-title">Welcome</h2>
      <h3>Please use this for emergency retrieval only</h3>

      <ol className="instructions">
        <li>Call the support team</li>
        <li>Get your unlock code and press next</li>
      </ol>
    </MobilePageLayout>
  );
};

export default HomePage;
